<div class="order-wrapper">
    <div class="order-details">
        <div class="container">
            <div class="row">
                <div class="col-8">
                    <h2>Your Order</h2>
                </div>
                <div class="col-4 text-right">
                    <img src="assets/icon/clear.svg" (click)="closeSheet();crossBtnGA()" alt="close" class="close-icon">
                </div>
                <div class="col-12 points mb-4">
                    <h2>+20</h2>
                    <h5>13 August, 1:52PM • Curbside Delivery</h5>
                </div>
                <hr>
            </div>
            <div class="row">
                <div class="col-8 h-4 mb-2">
                    <h4>2 x Dark Chocolate Mocha</h4>
                </div>
                <div class="col-4 h-4 mb-2 text-right">
                    <h4>₹750.oo</h4>
                </div>
                <div class="col-8 h-4 mb-2">
                    <h4>1 x Dark Chocolate Mocha</h4>
                </div>
                <div class="col-4 h-4 mb-2 text-right">
                    <h4>₹350.oo</h4>
                </div>
                <div class="col-8 h-4 mb-2">
                    <h4>4 x Butter Croissant</h4>
                </div>
                <div class="col-4 mb-2 h-4 text-right">
                    <h4>₹250.oo</h4>
                </div>
            </div>
        </div>
    </div>
    <div class="grey-footer mb-4">
        <div class="container">
            <div class="row">
                <div class="col-6">
                    <div class="total">
                        <p>Item Total</p>
                    </div>
                </div>
                <div class="col-6 text-right">
                    <p>₹1725</p>
                </div>
            </div>
            <div class="row">
                <div class="col-6">
                    <div class="tax">
                        <p>Taxes</p>
                    </div>
                </div>
                <div class="col-6 text-right">
                    <p>₹1725</p>
                </div>
            </div>
            <hr>
            <div class="row">
                <div class="col-6">
                 <h3>Grand Total</h3>
                </div>
                <div class="col-6 text-right">
                    <h3>₹2000</h3>
                </div>
            </div>
        </div>
    </div>
<div>
    <div class="col-12 text-center mb-4">
        <button  type="button" class="custom-btn btn-md-rounded btn-black">Repeat Order</button>
    </div>
</div>
</div>